module.exports = __webpack_public_path__ + "img/roof_center_alarm.de1a619e.png";